import type { UpdateAccountSettingsUpsellingsPayload } from '@fourthwall/services/dist/MembershipsCreatorApiClient'

import type { FormValues } from './types'

export const getUpdateAccountSettingsUpsellingsPayload = (
  formValues: FormValues,
): UpdateAccountSettingsUpsellingsPayload => {
  const { enabled, tier, value } = formValues

  if (enabled) {
    return {
      upselling: {
        tierId: Number(tier as string),
        minimumOrderValue: (value as number) * 100,
      },
    }
  }

  return {}
}
